import { render, staticRenderFns } from "./edit-term.vue?vue&type=template&id=69e87a03"
import script from "./edit-term.vue?vue&type=script&lang=ts"
export * from "./edit-term.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports